import React from 'react'
import {Link} from 'react-router-dom'
import he from 'he'

const ComedyGalleriesCard = ({item,index,hydrating}) => {

  const isTelugu = (text) => /[\u0C00-\u0C7F]/.test(text);

   const getPicturePageLink = (ref_url) => {

        const items = ref_url.replace(".html", '').split("-")
        const pictureId = items[items.length - 2]
        return `/pictures/Chitti-Archive-${pictureId}.html`
  }


       
  return (
    <div  className={`comedy-galleries-card ${hydrating ? 'ssr-hidden' : ''}`} >
      
               <Link className='gal-image-anchor' to={item.url_link ? getPicturePageLink(item.url_link) : '/'} >
              <img
                src={item.stimg ? item.stimg : '/comedy/assets/images/error_img.webp'}
                alt="card-img"
                className="comedy-galleries-card-img"
                loading={ index === 0 ? "eager" : index < 4 ? "auto" : "lazy"}
                fetchpriority={index === 0 ? "high"  : index < 4 ? "auto"  : "low" } />
               </Link>

    </div>
  )
}

export default ComedyGalleriesCard;
